// Statsig's Events

export const STATSIG_EVENT_NAMES = {
    LISTING_APP_PAGE_VIEW: 'Listing - App - View - Page',
    LISTING_CONVERSION_BAR_CTA_CLICK: 'Listing - conversionBar - Click - CTA',
    LISTING_ORGANIZER_TOP_FOLLOW_BUTTON_CLICK:
        'Listing - Hero Content - Follow Button - Change',
    LISTING_ORGANIZER_BOTTOM_FOLLOW_BUTTON_CLICK:
        'Listing - Organizer Profile - Follow Button - Change',
};

// Statsig's Feature Gates

export const DISPLAY_ORGANIZER_RATING_GATE = 'listing_display_organizer_rating';

// Statsig's Layers

export const LISTING_PAGE_TICKET_SELECTION_EXPERIMENT = {
    defaultValue: false,
    layer: 'listing_page_experiments',
    param: 'ticket_selection_visible',
};
